import { useAccountContext } from "@providers/AccountProvider";

// Connector names are internal ids, so only the ones that read as a vendor are shown.
const PROVIDER_DISPLAY_NAMES: Record<string, string> = {
    vetspire: "Vetspire",
    ezyvet: "ezyVet",
    shepherd: "Shepherd",
    daysmart: "DaySmart",
    pulse: "Pulse",
};

/** The clinic's PIMS as vets know it (Cornerstone, Avimark), from the same source Export.tsx uses. */
export function usePimsName(): string {
    const { pmsIntegrationData } = useAccountContext();
    const active =
        pmsIntegrationData?.find((o) => o.is_active && o.export_enabled) ??
        pmsIntegrationData?.find((o) => o.is_active);
    const vendor = active?.connected_third_party;
    if (vendor) return vendor;
    const connector = active?.integrations?.integration_name;
    return (connector && PROVIDER_DISPLAY_NAMES[connector]) || "your PIMS";
}
